import { AxiosPromise } from 'axios';
import axios from 'axios';

const uri = '/mgmt/point';

export const getPointInformation = (data: any): AxiosPromise<any> => {  
  return axios.get(`${uri}/${data.learningYearCode}/${data.semesterCode}/${data.semesterDiv}/${data.campusCode}/${data.classCode}`);
};

export const savePointInfomation = (data: any) => {
  return axios.post(`${uri}`, data);
}